import styles from '@/components/css/OrDivider.module.css';

export default function OrDivider() {
  return <div className={styles.orDivider}>or</div>;
}
